import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Add additional services that you want to use
// import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBrvnspKBylVYGOOIMN0q1z13PMiZzCs2w",
  authDomain: "deepstone-1eefc.firebaseapp.com",
  projectId: "deepstone-1eefc",
  storageBucket: "deepstone-1eefc.appspot.com",
  messagingSenderId: "258107517937",
  appId: "1:258107517937:web:32528f862f472a31e63250",
  measurementId: "G-BGBP8C73V6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);


export { db, auth, storage };
